import { useEffect, useRef } from 'react';
import type { LeafletEventHandlerFnMap } from '@anlan/gs-map';
import type { LeafletElement } from './element';

type EventedElement = { off(eventHandlers: LeafletEventHandlerFnMap): void; on(eventHandlers: LeafletEventHandlerFnMap): void }
export type EventedProps = { eventHandlers?: LeafletEventHandlerFnMap };

export function useEventHandlers(element: LeafletElement<EventedElement>, eventHandlers: LeafletEventHandlerFnMap | null | undefined) {
    const eventHandlersRef = useRef<LeafletEventHandlerFnMap | null | undefined>(undefined);
    useEffect(function addEventHandlers() {
        if (eventHandlers != null) {
            element.instance.on(eventHandlers);
        }
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) {
                element.instance.off(eventHandlersRef.current);
            }
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}
